import hoverintent from 'hoverintent';
export default class Nav {
  constructor() {
    this.toggleButtons = document.querySelectorAll('.js-toggle-menu');
    this.mainContent = document.querySelector('.js-main-content');
    this.siteHeader = document.querySelector('.js-header');
    this.siteBody = document.querySelector('.js-site-body');
    this.siteFooter = document.querySelector('.js-site-footer');
    this.dropdownButtons = document.querySelectorAll('.js-header-dropdown-button');
    this.dropdowns = document.querySelectorAll('.js-header-dropdown');
    this.dropdownLinks = document.querySelectorAll('.js-header-main-item');
    this.searchButton = document.querySelector('.js-search');
    this.searchModal = document.querySelector('.js-search-modal');
    this.searchCancel = document.querySelector('.js-search-cancel');
    this.navBorder = document.querySelector('.js-nav-border');
    this.subnav = document.querySelector('.js-subnav');

    this.animationDuration = 250;
    this.menuShown = false;

    // Add menu toggle button listers for mobile
    // There are two, one for main nav + one for CTA nav
    this.toggleButtons.forEach((toggleButton) => {
      toggleButton.addEventListener('click', () => this.toggleNav());
    });

    this.mediaQueryListener = window.matchMedia('(min-width: 1024px)');

    this.mediaQueryListener.addListener((e) => this.changeScreenSize(e));

    this.hidingTimeoutInsideMenu = {};
    this.hidingTimeoutOutOfMenu = {};
    this.showingTimeout = {};

    // Add dropdown toggle events
    this.dropdownButtons.forEach((dropdownButton) => {
      dropdownButton.addEventListener('click', (e) => this.dropdownToggle(e));
    });

    this.searchModal.addEventListener('click', (e) => {
      if (this.menuShown) {
        this.hideNav();
      }
    });

    // Add dropdown hover events (for non-mobile)
    this.dropdownLinks.forEach((dropdownLink) => {

      hoverintent(dropdownLink,
        (event) => {
          // Handler in
          this.handleMouseEnter(dropdownLink, event);
        }, (event) => {
          // Handler out
          this.handleMouseLeave(dropdownLink, event);
        }).options({
          timeout: this.animationDuration,
          interval: 50
        });
    });

    // Add scroll listener (to know when to show CTA in nav)
    this.lastScrollPosition = 0;
    this.scrollDirection = false; // false is up true is down
    this.headerScrolled = false;
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.scrolling();
          ticking = false;
        });

        ticking = true;
      }
    });

    // Add search button listener
    if(this.searchButton) {
      this.searchButton.addEventListener('click', (event) => this.showSearchModal(event));
    }
    if(this.searchCancel) {
      this.searchCancel.addEventListener('click', (event) => this.hideSearchModal(event));
    }
    // Add event listener for the Escape key
    document.addEventListener('keydown', (event) => this.handleKeydown(event));

    // On init, check scroll position and change styles depending on it
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.setHeaderScrolled(scrollTop);
    this.checkConversionHeader();

    // On init, auto-open nav dropdown if it contains an active item
    let active_nav_item = document.querySelector('.js-header-main-items .--active');

    if(active_nav_item && window.innerWidth < 1024) {
      let dropdown = active_nav_item.closest('.js-header-dropdown');

      if(dropdown) {
        dropdown.classList.add('--open');

        let button = dropdown.previousElementSibling;

        if(button && button.classList.contains('js-header-dropdown-button')) {
          button.classList.add('--opened');
        }
      }
    }
  }

  // show dropdown for dropdown link
  showDropdown(dropdownLink) {
    const dropdownIndex = dropdownLink.dataset.itemKey;

    dropdownLink.classList.add('--dropdown-activated');
    this.siteHeader.classList.add('--dropdown-showing');
    this.siteFooter.classList.add('--dropdown-shown');

    clearTimeout(this.hidingTimeoutInsideMenu[dropdownIndex]);
    clearTimeout(this.hidingTimeoutOutOfMenu[dropdownIndex]);

    this.showingTimeout[dropdownIndex] = setTimeout(() => {
      this.siteHeader.classList.add('--dropdown-shown');
    }, this.animationDuration);
  }

  // show dropdown for dropdown link when nav is already faded in
  showDropdownSimple(dropdownLink) {
    const dropdownIndex = dropdownLink.dataset.itemKey;

    clearTimeout(this.hidingTimeoutInsideMenu[dropdownIndex]);
    clearTimeout(this.hidingTimeoutOutOfMenu[dropdownIndex]);

    dropdownLink.classList.add('--dropdown-activated');
  }

  // hide dropdown for dropdown link
  hideDropdown(dropdownLink) {
    const dropdownIndex = dropdownLink.dataset.itemKey;

    dropdownLink.classList.add('--dropdown-hiding');
    clearTimeout(this.showingTimeout[dropdownIndex]);

    this.hidingTimeoutInsideMenu[dropdownIndex] = setTimeout(() => {
      dropdownLink.classList.remove('--dropdown-hiding');
      dropdownLink.classList.remove('--dropdown-activated');
    }, this.animationDuration);
  }

  handleMouseEnter(dropdownLink, event) {
    if (this.mediaQueryListener.matches) {
      const fromElement = event.relatedTarget;
      const toElement = event.target;

      const fromMenuItem = fromElement != null
        && (fromElement.classList.contains('js-header-main-item')
          || fromElement.parentElement.classList.contains('js-header-main-item'));
      const toMenuItem = toElement.classList.contains('js-header-main-item')
        || toElement.parentElement.classList.contains('js-header-main-item');

      if (!dropdownLink.classList.contains('--dropdown-hiding')) {
        if (!fromMenuItem && toMenuItem) {
          this.showDropdown(dropdownLink);
          this.hoverIntentTimer = setTimeout(() => {
            this.hoverIntentTimer = null;
          }, this.hoverIntentDuration);
        } else if (fromMenuItem && toMenuItem) {
          if (this.siteHeader.classList.contains('--dropdown-shown')) {
            this.showDropdownSimple(dropdownLink);
          } else {
            this.showDropdown(dropdownLink);
          }
        }
      } else {
        dropdownLink.classList.remove('--dropdown-hiding');
        dropdownLink.classList.remove('--dropdown-activated');

        if (this.siteHeader.classList.contains('--dropdown-shown')) {
          this.showDropdownSimple(dropdownLink);
        } else {
          this.showDropdown(dropdownLink);
        }
      }
    }
  }

  handleMouseLeave(dropdownLink, event) {
    if (this.mediaQueryListener.matches) {
      const fromElement = event.target;
      const toElement = event.relatedTarget;

      let fromMenuItem = false;

      this.dropdownLinks.forEach(dropdownLink => {
          if (dropdownLink.contains(fromElement)) {
            fromMenuItem = true;
          }
      })

      const toMenuItem = toElement != null && (toElement.classList.contains('js-header-main-item')
        || toElement.parentElement.classList.contains('js-header-main-item'));

      if (fromMenuItem && !toMenuItem) {
        this.siteHeader.classList.remove('--dropdown-shown', '--dropdown-showing');
        this.siteFooter.classList.remove('--dropdown-shown');

        this.hideDropdown(dropdownLink);
      } else {
        this.hideDropdown(dropdownLink);
      }
    }
  }

  changeScreenSize(e) {
    if (e.matches) {
      /* the viewport is medium or larger */
      this.hideNav();
    }
  }

  showNav() {
    this.menuShown = true;
    this.siteHeader.classList.add('--nav-shown');
    this.siteBody.classList.add('--nav-shown');
    this.siteFooter.classList.add('--nav-shown');
    document.querySelector('body').style.overflow = 'hidden';
  }

  hideNav() {
    this.menuShown = false;
    this.siteHeader.classList.remove('--nav-shown');
    this.siteBody.classList.remove('--nav-shown');
    this.siteFooter.classList.remove('--nav-shown');
    document.querySelector('body').style.overflow = '';

    // close all dropdowns
    this.dropdowns.forEach((dropdown) => {
      if (dropdown.classList.contains('--open')) {
        dropdown.classList.remove('--open');
      }
    });

    this.dropdownButtons.forEach((dropdownButton) => {
      if (dropdownButton.classList.contains('--opened')) {
        dropdownButton.classList.remove('--opened');
      }
    });
  }

  toggleNav() {
    if (this.menuShown) {
      this.subnav?.classList.remove('--hidden');
      this.hideNav();
    } else {
      this.subnav?.classList.add('--hidden');
      this.showNav();
    }
  }

  dropdownToggle(e) {
    const { target } = e;
    const { key } = target.dataset;
    const dropDownArray = [...this.dropdowns];
    const dropdownMatches = dropDownArray.filter((dropdown) => dropdown.dataset.dropdownKey === key); // eslint-disable-line max-len

    if (dropdownMatches.length === 1) {
      const dropdown = dropdownMatches[0];
      if (dropdown.classList.contains('--open')) {
        target.classList.remove('--opened');
        dropdown.classList.remove('--open');
      } else {
        target.classList.add('--opened');
        dropdown.classList.add('--open');
      }
    }
  }

  // checks the scroll position and sets what direction we are scrolling and how far we have scrolled
  scrolling() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.lastScrollPosition) {
      this.scrollDirection = true;
    } else {
      this.scrollDirection = false;
    }
    this.setHeaderScrolled(scrollTop);
    this.checkConversionHeader();
    this.lastScrollPosition = scrollTop;
  }

  // uses the scroll position to figure out if we need to shrink the header
  setHeaderScrolled(scrollPosition) {
    if (scrollPosition > 32) {
      this.headerScrolled = true;
    } else {
      this.headerScrolled = false;
    }
  }

  // checks to see if we have scrolled far enough and we are scrolling down the page
  checkConversionHeader() {
    if (!this.menuShown && !this.siteHeader.classList.contains("js-header-light")) { // only show conversion header if mobile nav is not opened.
      if (this.headerScrolled) {
        this.siteHeader.classList.add('--scrolled');
        this.navBorder.classList.add('--hidden');
      } else {
        this.siteHeader.classList.remove('--scrolled');
        this.navBorder.classList.remove('--hidden');
      }
    }
  }

  // show search modal
  showSearchModal() {
    this.searchModal.classList.add('--open');
    this.siteBody.parentElement.parentElement.classList.add('--no-scroll');
    this.siteFooter.classList.add('--search-modal-open');

    // focus on search input
    const searchField = document.querySelector('.search-field');
    if (searchField != null) {
      searchField.focus();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.searchModal.classList.contains('--open')) {
      this.hideSearchModal();
    }
  }

  hideSearchModal() {
    // this.searchModal.classList.remove('--open');
    this.siteBody.parentElement.parentElement.classList.remove('--no-scroll');
    // this.siteFooter.classList.remove('--search-modal-open');
  }
}
